import { render } from "./DetailBelumDipesan.vue?vue&type=template&id=b38dfef4"
import script from "./DetailBelumDipesan.vue?vue&type=script&lang=js"
export * from "./DetailBelumDipesan.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__